export const preOnboardingTags = {
  questionnaireStatus: 'questionnaireStatus',
} as const;
